export default "__VITE_ASSET__ed0ca222__"